<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import { toLuxon } from 'hydria/utils/time'

    import { Breadcrumb } from 'breadcrumb'

    import type { IEntry, IServer, IStat } from './nsd_defs'

    import Apdex from './Apdex.svelte'
    import BasicInfo from './BasicInfo.svelte'
    import Events from './Events.svelte'
    import Ping from './Ping.svelte'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    let serverId = $derived(route.result.path.params?.id)
    let serviceType: 'dns' | 'service' = $derived(route.result.path.params?.type)

    let loading = $state(false)
    let server: IServer | undefined = $state()
    let entries: IEntry[] | undefined = $state()
    let stats: IStat | undefined = $state()

    async function loadData(sId: string, sType: 'dns' | 'service') {
        let r: any
        loading = true
        try {
            r = await simpleFetch('GET', `/json/zone/1/server/${sId}/ping-stats/${sType}`)
        } catch (e) {
            console.error('Failed to load data:', e)
            notify({
                type: 'danger',
                title: 'Données',
                text: 'Une erreur est survenue lors du chargement de l’information.',
            })
            return
        }

        server = r.data.server
        entries = r.data.entries.map((entry: IEntry) => {
            entry.hour = toLuxon(entry.hour)
            return entry
        })

        stats = Object.fromEntries(
            ['avg', 'cnt', 'diff', 'max', 'min', 'stddev', 'sum'].map((key: string) => {
                return [key, r.data[key]]
            }),
        ) as IStat

        loading = false
    }
    loadData(serverId, serviceType)

    const crumbs = $derived.by(() => {
        let o: any

        return [
            {
                txt: server != null ? server.name : '…',
            },
            {
                txt: serviceType === 'service' ? 'Service' : serviceType === 'dns' ? 'NSD' : '…',
            },
        ]
    })
</script>

<Breadcrumb {crumbs} />

<div class="d-grid gap-4">
    <BasicInfo {serviceType} {loading} {server} />
    <Apdex {loading} {entries} />
    <Events {loading} {entries} />
    <Ping {loading} {entries} />
</div>
